'use client'

import Link from 'next/link'
import { JellyIcon } from '@/components/jelly-icon'

// Сообщение об исчерпанном недельном AI-лимите + предложение подписки
// (решение 2026-09-15: в момент упора в лимит пользователь должен видеть
// выбор «подождать до понедельника или открыть подписку», а не только
// «подождите»). Ссылка ведёт на /plans; когда появится оплата, менять
// ничего не нужно — кнопка уже стоит там, где нужно.
// Inline-стили: телефон может держать устаревший CSS-бандл.
// kind — что закончилось: 'chat' (реплики — помогает пакет +25 за 40 akçe),
// 'photo' (снимки — пакет +5 за 30 akçe) или другое (вопросы, озвучка —
// помогает «День Plus» за 100 akçe, раз в неделю). Магазин: /akce, цены в
// lib/akce.ts (тикет 87).
const AKCE_OFFER: Record<'chat' | 'photo' | 'other', string> = {
  chat: 'Пакет +25 реплик за 40 akçe',
  photo: 'Пакет +5 снимков за 30 akçe',
  other: 'День Plus за 100 akçe',
}

export function LimitNotice({ text, compact = false, kind = 'other' }: { text: string; compact?: boolean; kind?: 'chat' | 'photo' | 'other' }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: compact ? 6 : 8,
        padding: compact ? '8px 10px' : '12px 14px',
        borderRadius: 14,
        border: '1px solid oklch(0.78 0.14 228 / 0.45)',
        background: 'linear-gradient(165deg, oklch(0.6 0.14 25 / 0.16) 0%, oklch(0.22 0.04 25 / 0.3) 100%)',
        fontSize: compact ? 13 : 14,
        lineHeight: 1.45,
        color: 'oklch(0.9 0.03 240)',
      }}
    >
      <div>{text}</div>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '6px 12px' }}>
        <Link
          href="/plans"
          className="tk-btn-primary"
          style={{ display: 'inline-flex', alignItems: 'center', height: compact ? 30 : 34, padding: '0 14px', borderRadius: 9999, fontSize: compact ? 13 : 14, fontWeight: 700, textDecoration: 'none' }}
        >
          Больше AI в подписке
        </Link>
        <Link href="/akce" className={compact ? 'tk-pill tk-pill--sm pl-2 text-[13px]' : 'tk-pill tk-pill--sm pl-2'}>
          <JellyIcon emoji="🪙" size={20} radius={9999} /> {AKCE_OFFER[kind]}
        </Link>
        <span style={{ fontSize: compact ? 12 : 13, color: 'oklch(0.75 0.03 240)' }}>или подождать до понедельника</span>
      </div>
    </div>
  )
}
